import React from 'react';
import { Section } from './Section';
const stats = ['300+ Pages', '6 Volumes', '40+ Conditions & Populations', 'Word-for-word Scripts'];
const coverage = ['Spine & Back', 'Knees, Hips & Ankles', 'Shoulders, Wrists & Neck', 'Pregnancy & Postpartum', 'Older Adults & Hypermobility', 'Scope, Scripts & Referrals'];
export function ProductPresentation() {
  return <Section background="paper" labelledBy="product-heading" data-id="element-226" data-mp="235rz2i7js9k9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-227" data-mp="238d1b8brcrij">
        <p className="inline-flex rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-228" data-mp="284bk8gebhhbk">
          The complete injury decision system
        </p>

        <h2 id="product-heading" className="mt-7 font-serif text-4xl font-semibold leading-[1.1] text-ink sm:text-[52px]" data-id="element-229" data-mp="1ye0gouyjpa57">
          Screen &amp; Adapt™
        </h2>

        <p className="mt-4 font-sans text-lg leading-[1.6] text-ink" data-id="element-230" data-mp="2qwnv5rj1dqxb">
          6 Volumes + 5 Field Bonuses — from "she just mentioned an injury" to a calm, confident,
          in-scope class.
        </p>

        <p className="mt-6 font-sans text-[17px] leading-[1.65] text-ink-soft" data-id="element-231" data-mp="2uctufccrcl47">
          This is not an anatomy course. Not another certification. Not a 300-page book you're
          supposed to study. It's a decision system — built to be opened on your phone three minutes
          before class. 40+ conditions, each resolved in the same six blocks: what they'll say, what
          to ask next, the red flags, what to avoid, what to teach instead, and exactly what to SAY.
        </p>
      </div>

      <ul className="mx-auto mt-12 flex max-w-4xl flex-wrap items-center justify-center gap-x-6 gap-y-3 border-y border-sage/15 py-5" data-id="element-232" data-mp="3ry7yw44lym7e">
        {stats.map(stat => <li key={stat} className="font-sans text-[14px] font-semibold text-ink" data-id="element-233" data-mp="1xm1b85uj2cy7">
            {stat}
          </li>)}
      </ul>

      <ul className="mt-8 flex flex-wrap justify-center gap-2.5" data-id="element-234" data-mp="1snq442vmagjo">
        {coverage.map(item => <li key={item} className="rounded-full bg-sage-soft px-4 py-2 font-sans text-[13px] font-medium text-sage" data-id="element-235" data-mp="3sq7qzieododt">
            {item}
          </li>)}
      </ul>
    </Section>;
}